import "common/jiffy/cable";

export default (uuid, props) => {
  const params = { uuid, channel: "DtfChannel" };
  const { App } = window;

  return App.cable.subscriptions.create(params, {
    received() {
      console.info("DTF Channel received data");
    },
    connected() {
      console.info("DTF Channel connected");
    },
    disconnected() {
      console.info("DTF Channel disconnected");
    },
    ...props
  });
};
